import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { InvoicingService } from "./invoicing.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
declare var $: any;

@Component({
  templateUrl: "./invoicingdetail.component.html"
})
export class InvoicingDetailComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Invoicing';
  public invoiceName: string = '';
  public activeAccountId: string = '';
  public accessAccounts: IAccount[];
  public processAccount: IAccount;
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private invoicingService: InvoicingService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.route.params.subscribe(params => {      
      this.invoiceName = params['name'];
      this.accessAccounts = this.authService.getSelectedAccessAccounts();
      this.processAccount = null;
      this.processAccount = this.accessAccounts[0];

      if (this.invoiceName == 'invoices') {
        this.invoicesOnInit();
      }
      else if (this.invoiceName == 'historicalinvoices') {
        //debugger
        this.historicalinvoicesOnInit();
      }
      else if (this.invoiceName == 'statements') {
        this.statementsOnInit();
      }
      else if (this.invoiceName == 'certificates') {
        this.certificatesOnInit();
      }
      else if (this.invoiceName == 'payments') {
        this.paymentsOnInit();
      }
      else if (this.invoiceName == 'ebilling') {
        this.ebillingOnInit();
      }
    });
  }

  invoicesOnInit(): void {
    this.dtOptions = {
      dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      columnDefs: [{ width: 32, targets: 0 }, { orderable: false, targets: [0, 3] }, { bSearchable: false, targets: [0, 3] }],
      fixedColumns: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Download <i class="fa fa-angle-down"></i>',
          buttons: [
            'excelHtml5',
            //'csvHtml5',
            'pdfHtml5']
        }
      ]
    }
  }

  
  historicalinvoicesOnInit(): void {
    this.dtOptions = {
      dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      columnDefs: [{ width: 32, targets: 0 }, { orderable: false, targets: [0, 3] }, { bSearchable: false, targets: [0, 3] }],
      fixedColumns: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Download <i class="fa fa-angle-down"></i>',
          buttons: [
            'excelHtml5',
            //'csvHtml5',
            'pdfHtml5']
        }
      ]
    }
  }

  statementsOnInit(): void {
    this.dtOptions = {
      dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      columnDefs: [{ width: 32, targets: 0 }, { orderable: false, targets: [0, 3] }, { bSearchable: false, targets: [0, 3] }],
      fixedColumns: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Download <i class="fa fa-angle-down"></i>',
          buttons: [
            'excelHtml5',
            //'csvHtml5',
            'pdfHtml5']
        }
      ]
    }
  }

  certificatesOnInit(): void {

  }

  paymentsOnInit(): void {

  }

  ebillingOnInit(): void {

  }

  ngAfterViewInit(): void {

  }

  
}



// WEBPACK FOOTER //
// ./src/app/invoicing/invoicingdetail.component.ts